import React from 'react'
import { SxProps, Theme, useTheme, Stack, Typography } from '@mui/material'

const Radio: React.FC<{label?: string, onChange: () => void, checked: boolean, disabled?: boolean, labelSx?: SxProps<Theme>}> = ({onChange, label, checked = false, disabled = false, labelSx}) => {
  const theme = useTheme()
  return (
    <Stack direction={'row'} gap={.5} alignItems={'center'} justifyContent={'center'}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style={{ cursor: 'pointer' }}
        onClick={disabled ? () => {} : onChange}
      >
        <circle
          cx={8}
          cy={8}
          r={7}
          fill={'#DBE8FE'}
          strokeWidth={1}
          stroke={'#C3D9FD'}

        />
        {
          checked && (
            <circle
              cx={8}
              cy={8}
              r={4}
              fill={theme.palette.primary.main}
            />
          )
        }
        </svg>
      {
        Boolean(label) && (
          <Typography component={'span'} sx={{fontSize: 12, cursor: 'pointer', ...labelSx}} onClick={onChange}>{label}</Typography>
        )
      }
    </Stack>
    )
}

export default Radio
